import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'login',
        component: Login
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue')
    },
    {
        path: '/overview',
        name: 'overview',
        component: () => import(/* webpackChunkName: "overview" */ '../views/Dashboard.vue')
    },
    {
        path: '/inventory',
        name: 'inventory',
        component: () => import(/* webpackChunkName: "inventory" */ '../views/Inventory.vue')
    },
    {
        path: '/received',
        name: 'received',
        component: () => import(/* webpackChunkName: "received" */ '../views/Received.vue')
    },
    {
        path: '/sales',
        name: 'sales',
        component: () => import(/* webpackChunkName: "sales" */ '../views/Sales.vue')
    },
    {
        path: '/warehouse',
        name: 'warehouse',
        component: () => import(/* webpackChunkName: "warehouse" */ '../views/Warehouse.vue')
    },
    {
        path: '/distributors',
        name: 'distributors',
        component: () => import(/* webpackChunkName: "distributors" */ '../views/Distributors.vue')
    },
    {
        path: '/manufacturers',
        name: 'manufacturers',
        component: () => import(/* webpackChunkName: "manufacturers" */ '../views/Manufacturers.vue')
    },
    {
        path: '/manufacturers/:manufacturer_id',
        name: 'manufacturer-detail',
        props: true,
        component: () => import(/* webpackChunkName: "manufacturerdetail" */ '../views/Manufacturers.vue')
    },
    {
        path: '/promo-packs',
        name: 'promo-packs',
        component: () => import(/* webpackChunkName: "promo-packs" */ '../views/PromoPacks.vue')
    },
    {
        path: '/promo-packs/:push_pack_id',
        name: 'promo-packs-detail',
        props: true,
        component: () => import(/* webpackChunkName: "promo-packs-detail" */ '../views/PromoPacks.vue')
    },
    {
        path: '/promo-packs/products/:push_pack_id',
        name: 'promo-pack-products',
        props: true,
        component: () => import(/* webpackChunkName: "promo-pack-products" */ '../views/PromoPackProducts.vue')
    },
    {
        path: '/promo-packs/marquees/:push_pack_id',
        name: 'promo-pack-marquees',
        props: true,
        component: () => import(/* webpackChunkName: "promo-pack-marquees" */ '../views/PromoPackMarquees.vue')
    },
    {
        path: '/dlink',
        name: 'dlink',
        component: () => import(/* webpackChunkName: "dlink" */ '../views/Dlink.vue')
    },
    {
        path: '/dlink/carts',
        name: 'dlink-carts',
        component: () => import(/* webpackChunkName: "dlink-carts" */ '../views/DlinkCarts.vue')
    },
    {
        path: '/dlink/sales-reps',
        name: 'dlink-sales-reps',
        component: () => import(/* webpackChunkName: "dlink-sales-reps" */ '../views/DlinkSalesReps.vue')
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue')
    },
    {
        path: '/indexes',
        name: 'indexes',
        component: () => import(/* webpackChunkName: "indexes" */ '../views/AdminIndexes.vue')
    },
    {
        path: '/merge-products',
        name: 'merge-products',
        component: () => import(/* webpackChunkName: "merge-products" */ '../views/AdminMergeProducts.vue')
    },
    {
        path: '/merge-manufacturers',
        name: 'merge-manufacturers',
        component: () => import(/* webpackChunkName: "merge-manufacturers" */ '../views/AdminMergeManufacturers.vue')
    },
    {
        path: '/merge-calibers',
        name: 'merge-calibers',
        component: () => import(/* webpackChunkName: "merge-calibers" */ '../views/AdminMergeCalibers.vue')
    },
    {
        path: '/merge-suppliers',
        name: 'merge-suppliers',
        component: () => import(/* webpackChunkName: "merge-suppliers" */ '../views/AdminMergeSuppliers.vue')
    },
    {
        path: '/manage-clients',
        name: 'manage-clients',
        component: () => import(/* webpackChunkName: "manage-clients" */ '../views/AdminManageClients.vue')
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
